import { FC } from 'react';
import AsyncConfirmModal from './asyncConfirmModal/AsyncConfirmModal';

const ApplicationModals: FC = () => {
    return (
        <>
            <AsyncConfirmModal />
        </>
    );
};

export default ApplicationModals;
